export default __webpack_public_path__ + "static/media/btn_song_pause.253053da.png";